'use strict';

export default class SearchTiming extends React.Component {

    componentDidMount() {
        this.initSwiper();
    }
    componentDidUpdate(prevProps) {
        const prevItems = this.getItems(prevProps)
        const items = this.getItems()
        if(prevItems.length !== items.length) this.initSwiper();
    }

    initSwiper() {
        this.swiper = new Swiper(".search-timing .swiper", {
            slidesPerView: 6,
            loop: false,
            spaceBetween: 8,
            watchOverflow: false,
            navigation: {
                nextEl: ".search-timing__next",
                prevEl: ".search-timing__prev",
            },
        });
    }

    getItems(props = null) {
        const {type, timing} = props ? props : this.props;
        let items = [...timing];

        if(items.length === 0 || type !== 'seats') return [];

        if(items.length < 6) {
            [...Array(6 - items.length)].map((_, index) => {
                items.push({empty: true})
            })
        }

        return items;
    }

    getDate(date) {
        return moment(date.replace(/\./g, "/")).format('DD MMMM').toLowerCase();
    }

    getDay(date) {
        return moment(date.replace(/\./g, "/")).format('dddd').capitalize();
    }

    prepareDate(date) {
        return moment(date.replace(/\./g, "/")).format('DD.MM.YYYY').capitalize();
    }

    handleSelect(date) {
        const {routes, onSelect} = this.props;
        const newDate = this.prepareDate(date);
        if(newDate === routes[0].date) return;
        let newRoutes = [...routes];
        newRoutes[0].date = newDate
        onSelect(newRoutes);
    }

    render() {
        const {routes} = this.props;

        const items = this.getItems();

        if(items.length === 0) return null;

        return <div className="search-timing">
            <div className="search-timing__prev">
                <i className="icon-arrow6"/>
            </div>
            <div className="swiper">
                <div className="swiper-wrapper">
                    {items.map((item, index) => {

                        const showPrice = !item.price_by_request

                        if(item.empty) return <div
                            key={`timingSlide${index}`}
                            className="swiper-slide"
                        >
                            <div className="timing-item inactive"/>
                        </div>

                        const active = this.prepareDate(item.date) === routes[0].date;

                        return <div
                            key={`timingSlide${index}`}
                            onClick={() => this.handleSelect(item.date)}
                            className="swiper-slide"
                        >
                            <div className={clsx('timing-item',  {active})}>
                                <div className="timing-item__date">
                                    <span>{this.getDate(item.date)}</span>
                                    {this.getDay(item.date)}
                                </div>
                                <div className="timing-item__text">
                                    {item.shuttle && <span>Shuttle <sup>{item.shuttle}</sup></span>}
                                    {item.sharing && <span>Sharing <sup>{item.sharing}</sup></span>}
                                    {item.deal && <span>Deals <sup>{item.deal}</sup></span>}
                                </div>
                                <div className="timing-item__price">
                                    {!showPrice && <span>{tMsg('Цена по запросу')}</span>}
                                    {showPrice && item.has_prefix ? tMsg('от')+' ' : ''}
                                    {showPrice && item.fPrice}
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className="search-timing__next">
                <i className="icon-arrow6"/>
            </div>
        </div>
    }
}
